import styled from 'styled-components';
import { spacing } from '@chegg-ui/theme';
export var RecaptchaContainer = styled.div.withConfig({
  componentId: "sc-1qxzme2-0"
})(["display:flex;flex-direction:column;align-items:center;margin:", " 0 ", " 0;"], spacing.px24, spacing.px16);
export var ResetPasswordFlipContainer = styled.div.withConfig({
  componentId: "sc-1qxzme2-1"
})(["margin-top:", ";"], spacing.px12);